import { useEffect } from 'react';

/**
 * Actualise une requête Apollo toutes les `interval` millisecondes tant que l'onglet est affiché.
 * L'actualisation s'arrête quand l'onglet est caché et reprend, avec un rechargement immédiat, quand il redevient visible.
 */
export default function useVisiblePolling(
    startPolling: (interval: number) => void,
    stopPolling: () => void,
    refetch: () => any,
    interval: number,
) {
    useEffect(() => {
        function onVisibilityChange() {
            if (document.hidden) {
                stopPolling();
            } else {
                refetch();
                startPolling(interval);
            }
        }
        if (!document.hidden) {
            startPolling(interval);
        }
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', onVisibilityChange);
            stopPolling();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [interval]);
}
